// NOCTYVA tier decoy v5. On each single-SKU PDP (Coffee, AM DRIVE, PM REPLENISH),
// render tier cards (Single + bundles). Clicking a tier swaps the form variant ID
// and syncs the Subify widget pricing.
//
// v5: bundle tiers now support subscription via multi-line cart-add. When user is
// on a bundle tier with Subify "Subscribe" active, the form submit is intercepted
// and each component is added as a separate line item with the selling_plan
// attached. Subscribed bundle price = sum of component prices * 0.90, which beats
// the bundle one-time price. After 2026-06-09 pricing pass: bundle subscribe uses
// the 30% selling plan (Subify "Bundle Subscribe & Save 30%", id 4358406218)
// instead of the 10% one (4298080330). Components at 30% off:
//   Duo:   $84.98 * 0.70 = $59.49 (vs bundle one-time $67.99, saves $8.50)
//   Stack: $119.97 * 0.70 = $83.98 (vs bundle one-time $89.99, saves $6.01)
(function () {
  'use strict';

  var path = window.location.pathname;

  var TIERS_BY_PRODUCT = {
    '/products/noctyva-am-mushroom-coffee': [
      { id: 'single', label: 'NOCTYVA AM Mushroom Coffee', meta: 'Single bag, 30 servings. Subscribe and save 10%.', price: 39.99, variantId: '43650915500106', badge: null },
      { id: 'duo', label: 'NOCTYVA AM Morning Duo', meta: 'Save $16.99 vs separate one-time.', price: 67.99, subscribePrice: 76.48, variantId: '43649569357898', components: ['43650915500106', '43679249662026'], badge: 'MOST POPULAR' },
      { id: 'stack', label: 'NOCTYVA Vitality Stack', meta: 'Coffee + AM DRIVE + PM REPLENISH. Save $29.98 one-time.', price: 89.99, subscribePrice: 107.97, variantId: '43649569685578', components: ['43650915500106', '43679249662026', '43679249399882'], badge: 'BEST VALUE' }
    ],
    '/products/noctyva-am-drive': [
      { id: 'single', label: 'NOCTYVA AM DRIVE', meta: 'Single bottle, 30-day supply. Subscribe and save 10%.', price: 44.99, variantId: '43679249662026', badge: null },
      { id: 'duo', label: 'NOCTYVA AM Morning Duo', meta: 'Add the morning cup. Save $16.99 one-time.', price: 67.99, subscribePrice: 76.48, variantId: '43649569357898', components: ['43650915500106', '43679249662026'], badge: 'MOST POPULAR' },
      { id: 'stack', label: 'NOCTYVA Vitality Stack', meta: 'The full daily protocol. Save $29.98 one-time.', price: 89.99, subscribePrice: 107.97, variantId: '43649569685578', components: ['43650915500106', '43679249662026', '43679249399882'], badge: 'BEST VALUE' }
    ],
    '/products/noctyva-pm-replenish': [
      { id: 'single', label: 'NOCTYVA PM REPLENISH', meta: 'Single bottle, 30-day supply. Subscribe and save 10%.', price: 34.99, variantId: '43679249399882', badge: null },
      { id: 'stack', label: 'NOCTYVA Vitality Stack', meta: 'The full daily protocol: Coffee, AM DRIVE, PM REPLENISH. Save $29.98 one-time.', price: 89.99, subscribePrice: 107.97, variantId: '43649569685578', components: ['43650915500106', '43679249662026', '43679249399882'], badge: 'BEST VALUE' }
    ]
  };

  var TIERS = null;
  for (var key in TIERS_BY_PRODUCT) {
    if (path.indexOf(key) !== -1) { TIERS = TIERS_BY_PRODUCT[key]; break; }
  }
  if (!TIERS) return;

  var SUB_DISCOUNT = 0.10;
  var SELLING_PLAN = '4298080330'; // Single-tier subs use Subify default 10% plan
  function fmt(n) { return '$' + n.toFixed(2); }
  var selectedTier = 'single';

  function injectStyles() {
    if (document.getElementById('ntv-tier-styles')) return;
    var s = document.createElement('style');
    s.id = 'ntv-tier-styles';
    s.textContent =
      '.ntv-tier-grid{display:grid;gap:10px;margin:0 0 18px;padding:0;border:0;grid-template-columns:1fr;width:100%;}' +
      '.ntv-tier-grid__legend{display:block;width:100%;grid-column:1 / -1;font-family:inherit;font-size:.78rem;font-weight:600;letter-spacing:.12em;text-transform:uppercase;margin:0 0 4px;opacity:.65;}' +
      '.ntv-tier-card{position:relative;display:flex;flex-direction:column;align-items:stretch;padding:18px 16px;border:1px solid rgba(0,0,0,.18);border-radius:6px;background:#fff;color:inherit;cursor:pointer;text-align:left;box-sizing:border-box;transition:border-color .15s ease, box-shadow .15s ease;font-family:inherit;}' +
      '.ntv-tier-card > *{display:block;width:100%;margin:0;padding:0;box-sizing:border-box;}' +
      '.ntv-tier-card:hover{border-color:rgba(0,0,0,.5);}' +
      '.ntv-tier-card--active{border:2px solid #000;padding:17px 15px;box-shadow:0 1px 6px rgba(0,0,0,.06);}' +
      '.ntv-tier-card__radio{position:absolute;opacity:0;pointer-events:none;}' +
      '.ntv-tier-card__title{font-weight:600;font-size:.95rem;line-height:1.3;margin:0 0 6px !important;color:#000;overflow-wrap:break-word;}' +
      '.ntv-tier-card__meta{font-size:.8rem;line-height:1.45;opacity:.7;margin:0 0 10px !important;overflow-wrap:break-word;}' +
      '.ntv-tier-card__price{font-weight:700;font-size:1.05rem;line-height:1.2;color:#000;margin:0 !important;}' +
      '.ntv-tier-badge{position:absolute;top:-9px;right:14px;background:#000;color:#fff;padding:3px 9px;font-size:.6rem;font-weight:700;letter-spacing:.09em;text-transform:uppercase;border-radius:3px;}' +
      '#ntv-subscribe-note{font-size:.78rem;line-height:1.4;opacity:.7;margin-top:8px;padding:8px 12px;border:1px dashed rgba(0,0,0,.25);border-radius:4px;}';
    document.head.appendChild(s);
  }

  function getTier(id) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].id === id) return TIERS[i];
    return TIERS[0];
  }

  function isSubscribeActive() {
    var opts = document.querySelectorAll('.subify-minimal-option');
    for (var i = 0; i < opts.length; i++) {
      var t = opts[i].innerText || '';
      if (/subscribe/i.test(t) && !/one[- ]time/i.test(t) && opts[i].classList.contains('active')) return true;
    }
    return false;
  }

  function selectTier(tierId) {
    selectedTier = tierId;
    var tier = getTier(tierId);

    var cards = document.querySelectorAll('.ntv-tier-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var radio = card.querySelector('input[type="radio"]');
      if (card.dataset.tierId === tierId) {
        card.classList.add('ntv-tier-card--active');
        if (radio) radio.checked = true;
      } else {
        card.classList.remove('ntv-tier-card--active');
        if (radio) radio.checked = false;
      }
    }

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var f = 0; f < forms.length; f++) {
      var idInput = forms[f].querySelector('input[name="id"]');
      if (idInput) idInput.value = tier.variantId;
    }

    applyBundleNote(tier);
    syncSubifyPrices(tier);
  }

  function applyBundleNote(tier) {
    /* NTV: bundle-tier forces one-time */
    var subifyWrapper = document.querySelector('.subify-widget-container');
    var isBundle = tier.id !== 'single';
    if (subifyWrapper) {
      subifyWrapper.style.display = isBundle ? 'none' : '';
    }
    if (isBundle) {
      // Force the one-time radio so the cart-add doesn't carry a selling_plan
      // for the bundle parent (which 422s on Shopify). Subscriptions live on
      // single-product tier only.
      var opts = document.querySelectorAll('.subify-minimal-option');
      for (var i = 0; i < opts.length; i++) {
        var opt = opts[i];
        if (opt.classList.contains('one-time-purchase-option')) {
          if (!opt.classList.contains('active')) {
            ['pointerdown','mousedown','pointerup','mouseup','click'].forEach(function (t) {
              opt.dispatchEvent(new MouseEvent(t, { bubbles: true, cancelable: true, view: window, button: 0 }));
            });
          }
          break;
        }
      }
    }
    var note = document.getElementById('ntv-subscribe-note');
    if (note) note.style.display = 'none';
  }

  function syncSubifyPrices(tier) {
    var oneTimePrice = fmt(tier.price);
    var subPrice = tier.subscribePrice ? fmt(tier.subscribePrice) : fmt(tier.price * (1 - SUB_DISCOUNT));
    var origPrice = fmt(tier.price);

    var opts = document.querySelectorAll('.subify-minimal-option');
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var txt = opt.innerText || '';
      var isSub = /subscribe/i.test(txt) && !/one[- ]time/i.test(txt);
      var priceEl = opt.querySelector('.subify-minimal-price');
      var origEl = opt.querySelector('.subify-minimal-original-price');
      if (isSub) {
        if (priceEl) priceEl.textContent = subPrice;
        if (origEl) origEl.textContent = origPrice;
      } else {
        if (priceEl) priceEl.textContent = oneTimePrice;
      }
    }

    var topPrice = document.querySelector('.price__regular .price');
    if (topPrice) {
      var subActiveEl = document.querySelector('.subify-minimal-option.active');
      var subActiveText = subActiveEl ? subActiveEl.innerText : '';
      var isSubActive = /subscribe/i.test(subActiveText) && !/one[- ]time/i.test(subActiveText);
      topPrice.textContent = isSubActive ? subPrice : oneTimePrice;
    }
  }

  function buildCard(tier) {
    var card = document.createElement('div');
    card.className = 'ntv-tier-card';
    if (tier.id === 'single') card.classList.add('ntv-tier-card--active');
    card.dataset.tierId = tier.id;
    var checkedAttr = tier.id === 'single' ? ' checked' : '';
    var badgeHtml = tier.badge ? '<span class="ntv-tier-badge">' + tier.badge + '</span>' : '';
    card.innerHTML =
      '<input class="ntv-tier-card__radio" type="radio" name="ntv-tier" value="' + tier.id + '"' + checkedAttr + '>' +
      badgeHtml +
      '<span class="ntv-tier-card__title">' + tier.label + '</span>' +
      '<span class="ntv-tier-card__meta">' + tier.meta + '</span>' +
      '<span class="ntv-tier-card__price">' + fmt(tier.price) + '</span>';
    card.addEventListener('click', function (e) {
      e.preventDefault();
      selectTier(tier.id);
    });
    return card;
  }

  function findInjectionTarget() {
    return document.querySelector('.buy-buttons-block') ||
           document.querySelector('.variant-picker__form') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  function renderTiers() {
    var target = findInjectionTarget();
    if (!target) return false;
    if (document.querySelector('.ntv-tier-grid[data-ntv-rendered="1"]')) return true;

    injectStyles();

    var pickerForm = document.querySelector('.variant-picker__form');
    if (pickerForm) {
      var nativeOpt = pickerForm.querySelector('.variant-option');
      if (nativeOpt) nativeOpt.style.display = 'none';
    }

    var oldGrid = document.querySelector('.ntv-tier-grid');
    if (oldGrid) oldGrid.remove();

    var grid = document.createElement('div');
    grid.className = 'ntv-tier-grid';
    grid.setAttribute('role', 'radiogroup');
    grid.dataset.ntvRendered = '1';

    var legend = document.createElement('div');
    legend.className = 'ntv-tier-grid__legend';
    legend.textContent = 'Choose your pack';
    grid.appendChild(legend);

    for (var i = 0; i < TIERS.length; i++) grid.appendChild(buildCard(TIERS[i]));

    target.parentElement.insertBefore(grid, target);

    selectTier('single');
    return true;
  }

  // ===== Multi-line subscribed bundle add =====

  function handleFormSubmit(e) {
    var tier = getTier(selectedTier);
    // Only intercept when bundle tier + subscribe active + components defined
    if (!tier.components || !isSubscribeActive()) return;

    e.preventDefault();
    e.stopPropagation();

    var items = tier.components.map(function (vid) {
      return { id: parseInt(vid, 10), quantity: 1, selling_plan: parseInt(SELLING_PLAN, 10) };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    })
    .then(function () {
      // Try theme cart drawer
      var drawer = document.querySelector('cart-drawer-component, cart-drawer, [data-cart-drawer]');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (_) {}
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      // Fallback: navigate to /cart
      setTimeout(function () { window.location.href = '/cart'; }, 250);
    })
    .catch(function (err) {
      console.warn('NOCTYVA bundle subscribe add failed:', err);
      alert('Could not add bundle to cart. Please try again.');
    });
  }

  function attachFormHandler() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].dataset.ntvSubHandler === '1') continue;
      forms[i].addEventListener('submit', handleFormSubmit, true);
      forms[i].dataset.ntvSubHandler = '1';
    }
  }

  function attach() {
    if (renderTiers()) {
      setTimeout(function () { syncSubifyPrices(getTier(selectedTier)); }, 600);
    }
    attachFormHandler();

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.subify-minimal-option')) {
        setTimeout(function () { syncSubifyPrices(getTier(selectedTier)); }, 300);
      }
    });

    setTimeout(function () { renderTiers(); attachFormHandler(); }, 700);
    setTimeout(function () { renderTiers(); attachFormHandler(); }, 1800);
    setTimeout(function () { syncSubifyPrices(getTier(selectedTier)); }, 2000);
    setTimeout(function () { syncSubifyPrices(getTier(selectedTier)); }, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
